<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false">
    <div class="card-body">
        <div class="row">
            <div class="col-12 d-flex justify-content-start align-items-center">
              <b>Contributions Help Information Text:</b>
            </div>
            <div class="col-12">
                <textarea name="contributionInformation" class="form-control" id="contributionInformation" [(ngModel)]="contributionInfo" rows="8"></textarea>
            </div>
        </div>
    </div>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col text-left pl-0">
        <i class="material-icons rotate text-muted" *ngIf="disableButtons">loop</i>
        <button class="btn btn-secondary ml-2" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col text-right pr-0">
        <button class="btn btn-secondary" type="button" (click)="saveModal()">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
